export default __webpack_public_path__ + "static/media/a1-4-14.c659955d.jpg";